import {Button, styled, Typography, useTheme} from "@mui/material";
import CurrencyConverterDarkIcon from "assets/icons/CurrencyConverterDarkIcon";
import ProfileIcon from "assets/icons/ProfileIcon";
import {currencies as currencyFlags} from "assets/js/currenciesData";
import CurrencyInput from "components/Input/CurrencyInput";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {apiGetBusinessCurrencies, apiUpdateCurrencies} from "api/currencyApi";
import shortid from "shortid";
import {addOpenDrawer} from "store/actions/appAction";

const CurrencyDrawerWrapper = styled("div")(({theme}) => ({
    width: "100%",
    direction: "rtl",
    height: "100vh",
    position: "relative",
}));
const DrawerTitleContainer = styled("div")(({theme}) => ({
    height: "90px",
    padding: "16px",
    display: "grid",
    gridTemplateColumns: "15% 85%",
}));
const TitleLowerSection = styled("div")(({theme}) => ({
    display: "flex",
    justifyContent: "space-between",
}));
const ProfileText = styled("div")(({theme}) => ({
    width: "120px",
    paddingLeft: "20px",
    alignItems: "center",
    height: "30px",
    display: "flex",
    justifyContent: "space-between",
}));
const InputContainer = styled("div")(({theme}) => ({
    display: "flex",
    flexDirection: "column",
    padding: "16px 16px 16px 30px",
}));
const InputItem = styled("div")(({theme}) => ({
    marginBottom: "20px",
}));

const ActionButton = styled(Button)(({theme}) => ({
    height: "44px",
    fontSize: "16px",
}));
const ActionContainer = styled("div")(({theme}) => ({
    height: "44px",
    padding: "0 16px 0 16px",
    width: "100%",
    bottom: "20px",
    position: "absolute",
}));

const CurrencyDrawer = () => {
    const dispatch = useDispatch();
    const theme = useTheme();
    const nameUser = useSelector((state: any) => state.appReducer.user?.firstName ?? "");
    const familyUser = useSelector((state: any) => state.appReducer.user?.lastName ?? "");

    const {token} = useSelector((state: any) => state).businessReducer.business;

    const {businessCurrencies, lastUpdatedDate, currencies} = useSelector(
        (state: any) => state
    ).currencyReducer;

    const [values, setValues] = useState(
        businessCurrencies.map((item: any) => ({
            id: item.id,
            currencyExchange: item.currencyExchange,
            switched: false,
        }))
    );

    const [switchedArray, setSwitchedArray] = useState(businessCurrencies.map(() => false));

    const handleInputChange = (id: number, value: number, switched: boolean) => {
        const index = businessCurrencies.findIndex((item: any) => item.id === id);

        const newValues = [...values];

        newValues[index] = {id: id, currencyExchange: value, switched: switched};

        return setValues(newValues);
    };
    const handleSwitch = (id: number) => {
        const index = businessCurrencies.findIndex((item: any) => item.id === id);

        const newSwitchedArray = [...switchedArray];

        newSwitchedArray[index] = !newSwitchedArray[index];

        return setSwitchedArray(newSwitchedArray);
    };

    useEffect(() => {
        // @ts-ignore
        dispatch(apiGetBusinessCurrencies(token));
    }, [token]);

    const callback = () => {
        // @ts-ignore
        dispatch(apiGetBusinessCurrencies(token));
        return dispatch(addOpenDrawer(false));
    };
    return (
        <CurrencyDrawerWrapper>
            <DrawerTitleContainer>
                <CurrencyConverterDarkIcon/>
                {/* <TitleSection> */}
                <Typography variant="body1">جدول تبدیل ارز</Typography>
                <div></div>
                <TitleLowerSection>
                    <div
                        style={{
                            alignItems: "center",
                            height: "30px",
                            display: "flex",
                        }}
                    >
                        {lastUpdatedDate && (
                            <Typography color={theme.palette.disabled.main} variant="caption">
                                آخرین بروز رسانی : {lastUpdatedDate.split("-").reverse().join("-")}
                            </Typography>
                        )}
                    </div>
                    <ProfileText>
                        <ProfileIcon/>
                        <Typography color={theme.palette.disabled.main} variant="caption">
                            {`${nameUser} ${familyUser}`}
                        </Typography>
                    </ProfileText>
                </TitleLowerSection>
            </DrawerTitleContainer>
            <InputContainer>
                {businessCurrencies.map((item: any, key: number) => {
                    const object = currencies.find((it: any) => it.id === item.id);
                    const flag = currencyFlags.find((f) => f.unit === object?.en_title);

                    return (
                        object && (
                            <InputItem key={shortid.generate()}>
                                <CurrencyInput
                                    handleChange={handleInputChange}
                                    id={item.id}
                                    value={values.find((x: any) => x.id === item.id)?.currencyExchange || 0}
                                    sign={item?.en_title}
                                    Flag={flag?.Flag}
                                    label={item?.label}
                                    switched={switchedArray[key]}
                                    handleSwitch={handleSwitch}
                                />
                            </InputItem>
                        )
                    );
                })}
            </InputContainer>
            <ActionContainer>
                <ActionButton
                    onClick={() => {
                        const data = values.map((item: any) => ({
                            id: businessCurrencies.find((it: any) => it.id === item.id)?.businessCurrencyId,
                            currencyExchange: item.switched
                                ? (1 / item.currencyExchange).toString().replaceAll(",", "")
                                : item.currencyExchange.toString().replaceAll(",", ""),
                        }));
                        // @ts-ignore
                        dispatch(apiUpdateCurrencies(token, data, callback));
                    }}
                    disableRipple
                    fullWidth
                    variant="contained"
                >
                    ثبت تغییرات
                </ActionButton>
            </ActionContainer>
        </CurrencyDrawerWrapper>
    );
};

export default CurrencyDrawer;
